import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const NotFound = () => {
    const { isAuthenticated } = useAuth();

    return (
        <div style={{ 
            textAlign: 'center', 
            padding: '50px 20px',
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{ fontSize: '120px', color: '#ccc', marginBottom: '20px' }}>
                404
            </div>
            <h1 style={{ color: '#333', marginBottom: '20px' }}>
                Página no encontrada
            </h1>
            <p style={{ color: '#666', marginBottom: '30px', maxWidth: '500px' }}>
                La página que estás buscando no existe o no tienes permisos para acceder a ella.
            </p>
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <Link to="/home" style={{
                    padding: '12px 24px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '5px',
                    fontWeight: 'bold'
                }}>
                    Ir al Inicio
                </Link>
                {!isAuthenticated && (
                    <Link to="/login" style={{
                        padding: '12px 24px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontWeight: 'bold'
                    }}>
                        Iniciar Sesión
                    </Link>
                )}
            </div>
        </div>
    );
};

export default NotFound; 